import script from "./SaveTrainingReport.vue?vue&type=script&setup=true&lang=js"
export * from "./SaveTrainingReport.vue?vue&type=script&setup=true&lang=js"

import "./SaveTrainingReport.vue?vue&type=style&index=0&id=100726e9&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-100726e9"]])

export default __exports__